import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastService } from '../services/toast/toast.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HorizontalAlignment, VerticalAlignment } from 'igniteui-angular/core';
import { IgxToastComponent, IgxToastModule } from 'igniteui-angular/toast';

@Component({
  selector: 'app-toast',
  templateUrl: 'toastShow.component.html',
  styleUrls: ['toastShow.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IgxToastModule, CommonModule, TranslateModule],
})
export class ToastShowComponent implements OnDestroy, AfterViewInit {
  public showProgressBar = true;
  @ViewChild('toasttype')
  private toastObj: IgxToastComponent;
  public dataToast = null;
  public title: string;
  public content: string;
  private unsubscribe: Subscription[] = [];
  public closeImage = '../assets/img/close.webp';
  constructor(
    private toastService: ToastService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnDestroy() {
    this.unsubscribe.forEach((s) => s.unsubscribe());
  }

  ngAfterViewInit() {
    this.toastObj.positionSettings.verticalDirection = VerticalAlignment.Top;
    this.toastObj.positionSettings.horizontalDirection =
      HorizontalAlignment.Right;

    this.unsubscribe.push(
      this.toastService.visibility.subscribe((val) => {
        if (val) {
          this.title = val[0]['title'].toString();
          this.content = val[0]['content'].toString();
          this.dataToast = val[0];
          if (this.dataToast.cssClass.includes('info'))
            this.closeImage = '../assets/img/close_gray.webp';

          this.cdr.detectChanges(); // ← flush bindings before opening
          this.toastObj.open();
          // open() flips the toggle's collapsed state but only refreshes the toast's own view.
          // Its host bindings (aria-hidden, igx-toggle classes) live in this view, which the
          // zoneless targeted tick skips unless marked dirty -> NG0100 in dev mode.
          this.cdr.markForCheck();
        }
      }),
    );
  }

  closeToast() {
    this.toastObj.close();
  }

  onBeforeOpen(e) {
    if (1 === this.toastObj.element.childElementCount) {
      e.cancel = true;
    } else {
      e.cancel = false;
    }
  }
}
